import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { Group } from '../../group/domain/group';

export interface PendingHoldingSlice {
    relatesTo?: any[];
    group: Group
}
const initialState: PendingHoldingSlice = {
    group: {
        defaultDuration: 0,
        groupConfigs: [],
        members: [],
        name: '',
        packets: [],
        prefix: '',
        relatesTo: []
    }
};

const pendingGroupSlice = createSlice({
    initialState,
    name: 'temp-holding',
    reducers: {
        clearPendingHolding: () => {
            return initialState;
        }

        ,
        initializePendingHolding: () =>
            initialState
        ,
       
        setName: (state, action: PayloadAction<string>) => {
            state.group.name = action.payload;
            return state;
        },
        setPendingHolding: (state, action: PayloadAction<Group>) => {
            const grp = {...action.payload};
            if (grp?.id) {
                state.group = grp;
            }
            return state;
        },
        updatePendingHoldingProps: (state, action: PayloadAction<{ key: string, value: unknown }>) => {
            const { key, value } = action.payload;

            // handle nested properties
            if (key.includes('.')) {
                const [parentKey, childKey] = key.split('.');
                if (!state.group[parentKey]) state.group[parentKey] = {} as unknown;
                state.group[parentKey][childKey] = value;
            } else {
                state.group[key] = value;
            }
            return state;
        },
    },
});

export const { setPendingHolding, clearPendingHolding, updatePendingHoldingProps, setName } = pendingGroupSlice.actions;
export default pendingGroupSlice.reducer;